import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@type/index';
import { getVendorAvailabilityTime } from '..';

export const useVendorAvailability = (options?: UseQueryOptions<typeof getVendorAvailabilityTime>) =>
  useQuery({
    queryFn: getVendorAvailabilityTime,
    queryKey: ['vendor-availability-time-list'],
    ...options,
  });
